import { useMemo } from 'react';
import { LogLevel, type LogProps } from '@cabal/shared/util/seq-log';
import { emitSeqLog, IS_SEQ_LOG_ENABLED } from './seq-log-transport';

const SEQ_LOG_ENABLED = IS_SEQ_LOG_ENABLED;
type SeqLogger = (msg: string, propsOrLevel?: LogProps | LogLevel, maybeLevel?: LogLevel) => void;
const noopSeqLog: SeqLogger = () => {};

export function useSeqLog(component: string, context?: LogProps) {
  const serializedContext = SEQ_LOG_ENABLED ? JSON.stringify(context) : '';

  return useMemo(
    () => {
      if (!SEQ_LOG_ENABLED) {
        return noopSeqLog;
      }

      return (msg: string, propsOrLevel?: LogProps | LogLevel, maybeLevel?: LogLevel) => {
        const props = typeof propsOrLevel === 'object' ? propsOrLevel : undefined;
        const level = typeof propsOrLevel === 'string' ? propsOrLevel : (maybeLevel ?? LogLevel.Debug);
        emitSeqLog({ component, msg, props, level, context });
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [component, serializedContext],
  );
}
